import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE } from "./config";

import commonEs from "../locales/es/common.json";
import servicesEs from "../locales/es/services.json";
import blogsEs from "../locales/es/blogs.json";
import teamEs from "../locales/es/team.json";
import featuresEs from "../locales/es/features.json";
import counterEs from "../locales/es/counter.json";

import commonEn from "../locales/en/common.json";
import servicesEn from "../locales/en/services.json";
import blogsEn from "../locales/en/blogs.json";
import teamEn from "../locales/en/team.json";
import featuresEn from "../locales/en/features.json";
import counterEn from "../locales/en/counter.json";

import commonZh from "../locales/zh/common.json";
import servicesZh from "../locales/zh/services.json";
import blogsZh from "../locales/zh/blogs.json";
import teamZh from "../locales/zh/team.json";
import featuresZh from "../locales/zh/features.json";
import counterZh from "../locales/zh/counter.json";

const resources = {
  es: {
    common: commonEs,
    services: servicesEs,
    blogs: blogsEs,
    team: teamEs,
    features: featuresEs,
    counter: counterEs,
  },
  en: {
    common: commonEn,
    services: servicesEn,
    blogs: blogsEn,
    team: teamEn,
    features: featuresEn,
    counter: counterEn,
  },
  zh: {
    common: commonZh,
    services: servicesZh,
    blogs: blogsZh,
    team: teamZh,
    features: featuresZh,
    counter: counterZh,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: "common",
  ns: ["common", "services", "blogs", "team", "features", "counter"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
